import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter, Linkedin, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer style={{
    backgroundColor: '#1F2937'
  }} className="text-gray-300" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-92">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-93">
          {/* Brand */}
          <div data-id="element-94">
            <div className="flex items-center gap-2 mb-4" data-id="element-95">
              <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{
              backgroundColor: '#1B8F4B'
            }} data-id="element-96">
                <Globe className="w-5 h-5 text-white" data-id="element-97" />
              </div>
              <span className="font-bold text-white text-lg" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-98">
                Universal Global Logistics
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-4" style={{
            color: '#9CA3AF'
          }} data-id="element-99">
              Licensed waste carrier serving Chingford, North London, East
              London & Enfield. Eco-friendly, fully insured, and always on time.
            </p>
            <p className="text-sm font-semibold italic" style={{
            color: '#1B8F4B'
          }} data-id="element-100">
              "Green, Clean, and Always on Time."
            </p>
            <div className="flex gap-3 mt-5" data-id="element-101">
              {[Facebook, Instagram, Twitter, Linkedin].map((Icon, i) => <a key={i} href="#" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors hover:bg-[#1B8F4B]" style={{
              backgroundColor: '#374151'
            }} data-id="element-102">
                  <Icon className="w-4 h-4 text-white" data-id="element-103" />
                </a>)}
            </div>
          </div>

          {/* Services */}
          <div data-id="element-104">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-105">
              Our Services
            </h4>
            <ul className="space-y-2" data-id="element-106">
              {[['House Clearance', '/services/house-clearance'], ['Office Removals', '/services/office-removals'], ['Commercial Waste', '/services/commercial-waste'], ['Garden Waste', '/services/garden-waste'], ['Overseas Removals', '/services/overseas-removals'], ['Estate Agent Clearance', '/services/estate-agent'], ['Cost Calculator', '/calculator']].map(([label, href]) => <li key={href} data-id="element-107">
                  <Link to={href} className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-108">
                    {label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-109">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-110">
              Service Areas
            </h4>
            <ul className="space-y-2" data-id="element-111">
              {['Chingford', 'Enfield', 'North London', 'East London', 'Walthamstow', 'Tottenham', 'Edmonton', 'Hackney', 'All London Boroughs'].map(area => <li key={area} className="text-sm" style={{
              color: '#9CA3AF'
            }} data-id="element-112">
                  {area}
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-113">
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-114">
              Contact Us
            </h4>
            <ul className="space-y-3" data-id="element-115">
              <li className="flex items-start gap-2" data-id="element-116">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-117" />
                <a href="tel:+447405641227" className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-118">
                  07405 641227
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-119">
                <MessageCircle className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-120" />
                <a href="https://wa.me/447405641227" className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-121">
                  WhatsApp Us
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-122">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-123" />
                <a href="mailto:info@universalgloballogistics.co.uk" className="text-sm hover:text-[#1B8F4B] transition-colors" style={{
                color: '#9CA3AF'
              }} data-id="element-124">
                  info@universalgloballogistics.co.uk
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-125">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-126" />
                <span className="text-sm" style={{
                color: '#9CA3AF'
              }} data-id="element-127">
                  Chingford, London, UK
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-128">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-129" />
                <div className="text-sm" style={{
                color: '#9CA3AF'
              }} data-id="element-130">
                  <p data-id="element-131">Mon–Sat: 7am – 8pm</p>
                  <p data-id="element-132">Sun: 8am – 6pm</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t" style={{
      borderColor: '#374151'
    }} data-id="element-133">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-134">
          <p className="text-xs" style={{
          color: '#6B7280'
        }} data-id="element-135">
            © 2024 Universal Global Logistics Ltd. Licensed Waste Carrier.
          </p>
          <div className="flex gap-4" data-id="element-136">
            {['Privacy Policy', 'Terms & Conditions', 'Cookie Policy'].map(item => <a key={item} href="#" className="text-xs hover:text-[#1B8F4B] transition-colors" style={{
            color: '#6B7280'
          }} data-id="element-137">
                  {item}
                </a>)}
          </div>
        </div>
      </div>
    </footer>;
}